import { useContext, useState, useEffect } from 'react';
import '../css/user/adduser.css';
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { MdClose, MdPersonAdd, MdLock, MdContactPhone, MdAssignmentInd, MdPhotoCamera } from 'react-icons/md';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import api from '../../api';
import Swal from 'sweetalert2';
import { Eye, EyeOff } from "lucide-react";
import { storage } from '../../firebase'; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { ToastContainer } from 'react-toastify';
import { Datacontext } from '../../context/dataContext';

// Added 'users' to props to fix the UID calculation logic
export const Adduser = ({ set_add, showToast, userg, users }) => {
    const { setDim } = useContext(Dimcontext);
    const { user_Count, fetchcountuser } = useContext(Datacontext)
    const [uid, setuid] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [bt, setBt] = useState(false)
    
    const [userd, setuserd] = useState({
        name: "", password: "", password1: "", mobile: "",
        amobile: "", aadharno: "", relname: "", relmobile: "",
        docdet: "no", email: "",
    });

    // Calculate UID
    useEffect(() => {
            setuid(`TD-U/${String(user_Count?.data?.number).padStart(3, "0")}`)
    }, [user_Count]);

    // Handle Image Selection and Cleanup
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Revoke old preview URL to prevent memory leaks
            if (preview) URL.revokeObjectURL(preview);
            
            setImageFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };
    
    const handleaddclose = () => {
        if (preview) URL.revokeObjectURL(preview); // Cleanup on close
        setDim(false);
        set_add(false);
    };

    const add = async (e) => {
         setBt(true)
    e.preventDefault();
    
    if (userd.password.trim() !== userd.password1.trim()) {
         setBt(false)
        return showToast("Passwords do not match");
    }

    try {
        let imageUrl = "";

        // 1. Upload to Firebase Storage first (if an image exists)
        if (imageFile) {
            const storageRef = ref(storage, `user_profiles/${uid}_${imageFile.name}`);
            const uploadTask = await uploadBytesResumable(storageRef, imageFile);
            imageUrl = await getDownloadURL(uploadTask.ref);
        }

        // 2. Prepare the final data object
        const finalUserData = {
            uid: uid,
            name: userd.name?.toLowerCase(),
            email: userd.email,
            password: userd.password,
            role: "user",
            mobile: userd.mobile,
            amobile: userd.amobile,
            aadharno: userd.aadharno,
            relname: userd.relname?.toLowerCase(),
            relmobile: userd.relmobile,
            docdet: userd.docdet?.toLowerCase(),
            profileImage: imageUrl // The cloud URL
        };

        // 3. Send JSON to your backend
        await api.post('/register', finalUserData);
        
        Swal.fire({
            title: "User Created!",
            text: "The new account and profile photo have been saved.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
        });

        handleaddclose();
        userg(); 
        await api.put('user_count')
        fetchcountuser()
    } catch (error) { 
        console.error("Registration Error:", error); 
        showToast(error.response?.data?.message || "Failed to register user");
    } finally {
        setBt(false)
    }
};

    return (
        <div className='adduser-card shadow-lg'>
            <ToastContainer/>
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdPersonAdd className="me-2" />
                    <span>Create New Account</span>
                </div>
                <button onClick={handleaddclose} className='btn-close-custom'><MdClose /></button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(80vh - 70px)' }} noScrollX>
                <Form onSubmit={add} className="p-4">
                    
                    {/* Section: Profile Image */}
                    <div className="form-section text-center mb-4">
                        <h6 className="section-title text-start"><MdPhotoCamera className="me-2"/>Profile Photo</h6>
                        <div className="d-flex align-items-center gap-4 p-3 border rounded bg-light">
                            <div className="preview-container">
                                {preview ? (
                                    <img src={preview} alt="User" className="rounded-circle shadow" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                ) : (
                                    <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white shadow" style={{ width: '80px', height: '80px' }}>
                                        No Image
                                    </div>
                                )}
                            </div>
                            <div className="flex-grow-1 text-start">
                                <FormLabel className="small text-muted">Upload profile picture (JPG/PNG)</FormLabel>
                                <FormControl type="file" accept="image/*" onChange={handleFileChange} />
                            </div>
                        </div>
                    </div>

                    {/* Section: Identity Details */}
                    <div className="form-section">
                        <h6 className="section-title"><MdAssignmentInd className="me-2"/>Identity Details</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>User ID</FormLabel>
                                    <FormControl className="input-readonly" readOnly value={uid} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Full Name</FormLabel>
                                    <FormControl required type='text' value={userd.name} onChange={(e) => setuserd({ ...userd, name: e.target.value })} placeholder='Enter full name' />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Email Address</FormLabel>
                                    <FormControl required type='email' value={userd.email} onChange={(e) => setuserd({ ...userd, email: e.target.value })} placeholder='name@example.com' />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>ID Number</FormLabel>
                                    <FormControl required type='text' pattern="[0-9]{12}" maxLength={12} value={userd.aadharno} onChange={(e) => setuserd({ ...userd, aadharno: e.target.value.replace(/\D/g, "") })} placeholder='12-digit number' />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Contact Information */}
                    <div className="form-section">
                        <h6 className="section-title"><MdContactPhone className="me-2"/>Contact Information</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Primary Mobile</FormLabel>
                                    <FormControl required maxLength={10} pattern="[0-9]{10}" value={userd.mobile} onChange={(e) => setuserd({ ...userd, mobile: e.target.value.replace(/\D/g, "") })} placeholder='10-digit mobile' />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Alternate Mobile</FormLabel>
                                    <FormControl maxLength={10} pattern="[0-9]{10}" value={userd.amobile} onChange={(e) => setuserd({ ...userd, amobile: e.target.value.replace(/\D/g, "") })} placeholder='Secondary mobile' />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Name</FormLabel>
                                    <FormControl required value={userd.relname} onChange={(e) => setuserd({ ...userd, relname: e.target.value })} placeholder='Relative/Guardian' />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Mobile</FormLabel>
                                    <FormControl required maxLength={10} pattern="[0-9]{10}" value={userd.relmobile} onChange={(e) => setuserd({ ...userd, relmobile: e.target.value.replace(/\D/g, "") })} placeholder='Relative contact' />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Security */}
                    <div className="form-section">
                        <h6 className="section-title"><MdLock className="me-2"/>Security & Verification</h6>
                        <Row className="g-3">
                            <Col md={6}>
    <FormGroup className="position-relative">
        <FormLabel>Password</FormLabel>
        <div className="password-wrapper" style={{ position: 'relative' }}>
            <FormControl 
                required 
                type={showPassword ? 'text' : 'password'} 
                value={userd.password} 
                onChange={(e) => setuserd({ ...userd, password: e.target.value })} 
                placeholder='Create password' 
                style={{ paddingRight: '40px' }} // Make space for the icon
            />
            <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#6c757d',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
        </div>
    </FormGroup>
</Col>

<Col md={6}>
    <FormGroup>
        <FormLabel>Confirm Password</FormLabel>
        <FormControl 
            required 
            type='text' // Always 'text' as per your requirement
            value={userd.password1} 
            onChange={(e) => setuserd({ ...userd, password1: e.target.value })} 
            placeholder='Repeat password' 
        />
    </FormGroup>
</Col>
                            <Col md={12}>
                                <FormGroup className="doc-collect-box">
                                    <FormLabel className="me-4 fw-bold mb-0">Original Document Collected?</FormLabel>
                                    <Form.Check inline type="radio" label="Yes" name='docdet' id='docdety' value='yes' onChange={(e) => setuserd({ ...userd, docdet: e.target.value })} checked={userd.docdet === 'yes'} />
                                    <Form.Check inline type="radio" label="No" name='docdet' id='docdetn' value='no' onChange={(e) => setuserd({ ...userd, docdet: e.target.value })} checked={userd.docdet === 'no'} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions">
                        <Button variant="secondary" className="px-4" onClick={handleaddclose}>Cancel</Button>
                        <Button type='submit' className="btn-submit px-5" disabled={bt}>Register User</Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    );
};